<template>
  <div class="Fuell-Table--row">
    <div
      class="Fuell-Table--item clickable"
      @click="navigateUserDetail"
    >
      <div class="flex dark">
        <user-name-badge
          :userName="fullUserName"
          :userAvatarId="userProfilePictureId"
        ></user-name-badge>
        <span class="ellipsis">
          {{user && user.firstName  ? `${user.firstName} ${user.lastName ? user.lastName : ''}` : ''}}
        </span>
      </div>
    </div>

    <div
      class="Fuell-Table--item"
      v-tooltip="user && user.email ? user.email : ''"
    >
      <span class="ellipsis black">
        {{user && user.email ? user.email : ''}}
      </span>
    </div>

    <div class="Fuell-Table--item black">
      {{userRoleLabel}}
    </div>

    <div class="Fuell-Table--item">
      <span
        :class="userStatusClass"
        v-if="userStatus"
      >
        {{$t(`user_status__${userStatus.statusType.code}`)}}
      </span>
    </div>

    <!-- <div
      class="Fuell-Table--item clickable"
      @click="navigateUserDetail"
    >
      <span
        :class="cardStatusClass"
        v-if="cardStatus"
      >
        {{$t(`card_status__${cardStatus}`)}}
      </span>
    </div> -->
    <div
      class="Fuell-Table--item clickable"
      @click="navigateUserBudgets"
    >
      <span>
        {{userBudgets}}
      </span>
    </div>
    <div
      class="Fuell-Table--item clickable"
      @click="navigateUserDetail"
    >
      <span>
        {{userIdentifier}}
      </span>
    </div>
    <div
      class="Fuell-Table--item clickable"
      @click="navigateUserDetail"
    >
      <span>
        {{userExpenseCenter}}
      </span>
    </div>
    <div
      class="Fuell-Table--item clickable"
      @click="navigateUserDetail"
    >
      <div class="d-flex w-100 justify-content-center">
        {{userCreatedAt | formatTheDate('short')}}
      </div>

    </div>

    <div
      class="Fuell-Table--item Fuell-Table--options Fuell-Dropdown--button-dots"
      @click.stop
    >
      <button
        v-if="showUserActionsButtons"
        class="Fuell-IconButton Fuell-IconButton--no-margin dots"
        aria-hidden="true"
        @click="showUserActionsModal"
      >
        <img
          :src="require(`@/assets/img/icons/icon-dots.svg`)"
          alt="options"
        />
      </button>
    </div>
  </div>
</template>

<script>
import _userDetailHandler from '../../_mixins/_userDetailHandler'
import _userRoleHandlerMixin from '../../_mixins/_userRoleHandlerMixin'
import UserNameBadge from '@/components/Commons/UserNameBadge'
import { segmentTrack } from '@/analytics/segment'
export default {
  name: 'UserListTableRow',
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  components: { UserNameBadge },
  mixins: [_userDetailHandler, _userRoleHandlerMixin],
  data () {
    return {
      selectedRoles: [],
      editFlag: false,
      updatedUser: {
        id: this.user.id,
        firstName: this.user.firstName,
        lastName: this.user.lastName,
        email: this.user.email
      },
      userAvatar: null
    }
  },
  methods: {
    archiveUser () {
      this.$store.dispatch('UsersStore/archiveUser', this.user.id)
    },
    activateUser () {
      this.$store.dispatch('UsersStore/activateUser', this.user.id)
    },
    navigateUserDetail () {
      if (this.isUser) return
      segmentTrack('User selected', {
        user_id: this.user.id,
        user_name: this.fullUserName,
        invited_on: this.$moment.utc(this.userCreatedAt).format('DD/MM/YY'),
        role: this.user.roles.join(','),
        membership_status: this.userStatus.statusType.code,
        physical_card_status: this.cardStatus

      })

      this.$router.push(`/users/detail/${this.user.id}`)
    },
    navigateUserBudgets () {
      this.$router.push(`/users/detail/${this.user.id}/budgets`)
    },
    showUserActionsModal () {
      this.$emit('showUserActionsModal', this.user.id)
    },
    async submitChange () {
      let updatedUser = {
        id: this.user.id
      }
      await this.$store.dispatch('UsersStore/updateUser', updatedUser)
    },
    handleCurrencyInputKeyDown (event) {
      if (event.keyCode === 13) {
        this.submitChange()
      }
    }

  },
  computed: {
    userIdentifier () {
      return this.user.identifier
    },
    userExpenseCenter () {
      return this.user.expenseCenter
    },
    userBudgets () {
      return this.user.budgetsCount || 0
    },
    isSuperAdmin () {
      return this.$store.getters['LoginStore/isSuperAdmin']
    },
    isAdmin () {
      return this.$store.getters['LoginStore/isAdmin']
    },
    adminRoles () {
      return this.$store.getters['LoginStore/adminRoles']
    },
    isUser () {
      return this.$store.getters['LoginStore/isUser']
    },
    isOwnerOfAnyBudget () {
      return this.$store.getters['LoginStore/isOwnerOfAnyBudget']
    },
    hasOfficeOwnerInviteUserFeature () {
      return this.$store.getters['CompanyStore/currentCompanyFeatures'].findIndex(el => el.feature.code === 'OWNER_INVITE_USER') >= 0
    },

    showUserActionsButtons () {
      if (this.user.roles.some(el => ['ROLE_SUPER_ADMIN'].includes(el))) {
        return false
      }

      if (this.isSuperAdmin) {
        return true
      }
      const userIsOwnerAndHasInviteFeature = this.isUser && this.isOwnerOfAnyBudget && this.hasOfficeOwnerInviteUserFeature

      return (this.isAdmin || userIsOwnerAndHasInviteFeature) && !this.user.roles.some(el => this.adminRoles.includes(el))
    }

  }

}
</script>
<style scoped>
.blurred-text {
  color: transparent;
  text-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
}
</style>

<style scoped src="@/assets/styles/multiselect/table.css"></style>
